import { useFormField } from '~/shared/forms/useFormField';
import type { StripControlledProperties } from '~/shared/forms/types';
import { DateTimeField, type DateTimeFieldProps } from '../../base-fields/DateTimeField';

export function DateTimeFormField(props: StripControlledProperties<DateTimeFieldProps>) {
	const fieldProps = useFormField<Date | null>(props);

	return <DateTimeField {...props} {...fieldProps} />;
}
